import { jsxs as b, jsx as n, Fragment as A } from "react/jsx-runtime";
import { Alert as _, AlertDescription as N, Button as U } from "@zapier/design-system";
import E from "react";
import { createPortal as P } from "react-dom";
import I from "classnames";
import { TemplateCreationModal as g } from "./components/TemplateCreationModal/TemplateCreationModal.es.js";
import { e as O } from "./emitEvent-B5xAYp5K.mjs";
import { UserInteractionEventName as M, ENTRY_POINT_METHOD_QUERY_PARAM as R, ENTRY_POINT_LOCATION_QUERY_PARAM as W, ENTRY_POINT_LOCATION as y } from "./observability/tracking/trackingTypes.es.js";
const F = "_alertContainer_7elwz_1", k = "_buttonWrapper_7elwz_11", Y = "_allowMobileFullWidth_7elwz_20", f = {
  alertContainer: F,
  buttonWrapper: k,
  allowMobileFullWidth: Y
};
var z = function(e) {
  var t = e.tryTemplateActions, a = e.webIntentUrl, o = e.slug, l = e.products, v = t.createTemplate, m = t.hasCreationScreen, i = t.creationError, c = t.setCreationError, s = !!a?.trim(), p = function(r) {
    var d = r.slug, u = r.webIntentUrl, h = r.createTemplate, w = r.onClick;
    if (O(M.templateCreateClicked, {
      event_action: "click",
      option_selected: d
    }), w) {
      w();
      return;
    }
    if (u) {
      var T = new URL(u, window.location.origin);
      T.searchParams.set(L, x), T.searchParams.set(R, "discover_template"), T.searchParams.set(W, y), window.location.href = T.href;
      return;
    }
    h(d);
  }, C = function() {
    return /* @__PURE__ */ b(E.Fragment, { children: [
      !s && i && P(/* @__PURE__ */ n("div", { className: I(f.alertContainer), children: /* @__PURE__ */ n(_, { onDismiss: function() {
        c(null);
      }, status: "error", variant: "alert", title: "Error", children: /* @__PURE__ */ n(N, { children: i }) }) }), document.body),
      !s && m && o && l && /* @__PURE__ */ n(g, { slug: o, products: l })
    ] });
  };
  return {
    createTemplate: v,
    hasCreationScreen: m,
    creationError: i,
    setCreationError: c,
    isWebIntent: s,
    renderCreationUI: C,
    createTemplateAndNavigate: p
  };
}, L = "copilot_prompt", x = "Help finish setting up my Zap", G = function(e) {
  var t, a = e.children, o = e.slug, l = e.webIntentUrl, v = e.products, m = e.tryTemplateActions, i = e.onClick, c = e.size, s = c === void 0 ? "medium" : c, p = e.allowMobileFullWidth, C = p === void 0 ? !1 : p, r = z({
    tryTemplateActions: m,
    webIntentUrl: l,
    slug: o,
    products: v
  }), d = r.createTemplate, u = r.createTemplateAndNavigate, h = r.renderCreationUI;
  return /* @__PURE__ */ b(A, { children: [
    h(),
    /* @__PURE__ */ n("div", { className: I(f.buttonWrapper, (t = {}, t[f.allowMobileFullWidth] = C, t)), children: /* @__PURE__ */ n(U, { size: s, onClick: function() {
      return u({
        slug: o,
        webIntentUrl: l,
        createTemplate: d,
        onClick: i
      });
    }, children: a }) })
  ] });
};
export {
  L as C,
  G as T,
  x as a,
  z as u
};
//# sourceMappingURL=TryTemplateButton-DZeOCsyJ.mjs.map
